<script lang="ts" setup>
	defineProps<{
		note: string
	}>()
</script>

<template>
	<div>
		<div
			class="flex min-h-[96px] w-full items-center gap-4 rounded-lg border border-gray-200 bg-gray-50 px-[27px] py-6"
		>
			<lazy-tools-icon icon="purple-light-bulb" dir="other" :height="32" :width="32" />
			<div class="font-normal tracking-wide text-gray-700">
				<span class="mr-1 font-semibold">Tips: </span>
				<span>{{ note }}</span>
			</div>
		</div>
	</div>
</template>
